<template>
  <div class="online-rates">
      <div class="online-rates-input">
        <span class="trend-title">电表</span>
        <el-input type="number" placeholder="请输入" v-model="allOnlineWatch.powerLine">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">水表</span>
        <el-input type="number" placeholder="请输入" v-model="allOnlineWatch.waterLine">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">气表</span>
        <el-input type="number" placeholder="请输入" v-model="allOnlineWatch.gasLine">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="last-save">
        <el-button :loading="onlinePLoading" size="small" type="primary" @click="saveOnlineRate">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      onlinePLoading:false,//加载状态
      //数据
      allOnlineWatch:{
        powerLine:'',//电表
        waterLine:'',//水表
        gasLine:'',//气表
      },
    }
  },
  mounted(){
    this.getOnlineRate();//获取采集设备在线率
  },
  methods:{
    //保存采集设备在线率
    saveOnlineRate(){
      this.onlinePLoading = true;
      apis.saveDevLine(this.allOnlineWatch).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.onlinePLoading = false;
          this.getOnlineRate()
        }else{
          this.$message.error(res.message);
          this.onlinePLoading = false;
          return;
        }
      })
    },
    //获取采集设备在线率
    getOnlineRate(){
      apis.getDevLine().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.allOnlineWatch = res.data
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.online-rates{ padding-top: 10px;
  .online-rates-input{ margin-bottom: 15px;
    .trend-title{ width: 8.35rem;}
    .el-input,.el-select{ display: inline-block; width: 12rem;}
  }
}
</style>
